;(function ($) {
  $.shopgate = $.shopgate || {};

  $.shopgate.systemMessage = {
    previousMessage: '',
    hintContainer: null,
    showHintOnWindowLoad: false,
    options: {}
  };

  /***
   * Helper function for notificatios aka flash messages
   * @param {object} messageObject
   * @param {object} options
   */
  $.shopgate.systemMessage.init = function (messageObject, options) {
    var defaults = {
      constants: {
        DISPLAY_BEHAVIOR_POPUP: 'popup',
        DISPLAY_BEHAVIOR_HINT_STATIC: 'hint_static',
        DISPLAY_BEHAVIOR_POPUP_AND_HINT_STATIC: 'popup_and_hint_static',
        DISPLAY_BEHAVIOR_HINT_FIXED: 'hint_fixed',
        MESSAGE_OK: 'message_ok',
        MESSAGE_ERROR: 'message_error',
        MESSAGE_NEUTRAL: 'message_neutral',
        MESSAGE_COUPON_ADDED: 'coupon_added'
      },
      flashMessageSelector: '.flash-message',
      useNativePopup: false,
      successTimeout: 5000, // time im ms
      couponCallback: null // TODO: remove this extra coupon logic and use new notification system for coupon popup
    };

    options = options || {};
    options = $.extend({}, defaults, options);
    $.shopgate.systemMessage.options = options;

    $(document).bind('sgFramework.message.system', function (e, messageObject) {

      $.shopgate.systemMessage.initHint(options);

      if (messageObject && typeof messageObject.message !== 'undefined' && messageObject.message) {

        // TODO: remove this extra coupon logic and use new notification system for coupon popup
        if (messageObject.state == options.constants.MESSAGE_COUPON_ADDED && typeof options.couponCallback === 'function') {
          options.couponCallback(messageObject.message);
          return true;
        }

        // POPUP AS FALLBACK
        if (typeof messageObject.display_behavior === 'undefined') {
          messageObject.display_behavior = options.constants.DISPLAY_BEHAVIOR_POPUP;
        }

        var displayBehavior = messageObject.display_behavior;

        /**
         * Manage the display behaviors
         */
        if (displayBehavior == options.constants.DISPLAY_BEHAVIOR_POPUP) {
          $.shopgate.systemMessage.showPopup(messageObject, options);
        } else if (displayBehavior == options.constants.DISPLAY_BEHAVIOR_POPUP_AND_HINT_STATIC) {
          $.shopgate.systemMessage.showPopup(messageObject, options);
          $.shopgate.systemMessage.showHint(messageObject, options);
        } else if (displayBehavior == options.constants.DISPLAY_BEHAVIOR_HINT_FIXED) {
          $.shopgate.systemMessage.showHintFixed(messageObject, options);
        } else {
          $.shopgate.systemMessage.showHint(messageObject, options);
        }
      } else {
        // reset the previous message so that no old message will be shown by the sgViewAppear Event (e.g. the min order value(€) is not reached message)
        $.shopgate.systemMessage.previousMessage = '';
      }
    });

    if (messageObject) {
      // if the page is newly loaded and the system message is set to the view we want to show in on window load
      $.shopgate.systemMessage.showHintOnWindowLoad = true;
      $(document).trigger('sgFramework.message.system', [messageObject]);
    }
  };

  $.shopgate.systemMessage.initHint = function (initOptions) {
    initOptions = initOptions || {};
    $.shopgate.systemMessage.hintContainer = $(initOptions.flashMessageSelector).removeClass('error neutral fixed flash-shown flash-hidden').empty().hide();
  };

  $.shopgate.systemMessage.showHintFixed = function (messageOptions, initOptions) {
    messageOptions = messageOptions || {};
    initOptions = initOptions || {};

    var $hintContainer = $.shopgate.systemMessage.hintContainer,
        hintTimeout    = null;

    // show and close on click
    $hintContainer
      .addClass('fixed')
      .bind('click', function () {
        _closeHint($(this));
      });

    // closing timeout
    var disappearTimeout = (messageOptions.state == initOptions.constants.MESSAGE_ERROR) ? 0 : initOptions.successTimeout;

    if ($.shopgate.systemMessage.showHintOnWindowLoad) {
      // window load function is necessary - otherwise success messages won't show as their timeout will expire while the page is still loading and the needed informations are not visible.
      $(window).load(function () {
        _closeTimeout();
        $.shopgate.systemMessage.showHintOnWindowLoad = false;
      });
    } else {
      _closeTimeout();
    }

    function _closeTimeout() {
      if (disappearTimeout > 0) {
        hintTimeout = window.setTimeout(function () {
          _closeHint($hintContainer);
        }, disappearTimeout);
      }
    }

    function _closeHint($hint) {
      $hint.removeClass('flash-shown').addClass('flash-hidden').hide();

      if (hintTimeout != null) {
        window.clearTimeout(hintTimeout);
      }
    }

    $.shopgate.systemMessage.showHint(messageOptions, initOptions);
  };

  $.shopgate.systemMessage.showHint = function (messageOptions, initOptions) {
    messageOptions = messageOptions || {};
    initOptions = initOptions || {};

    var $hintContainer = $.shopgate.systemMessage.hintContainer;

    $hintContainer.html(messageOptions.message).addClass('flash-shown').show();

    var additionalClass = {};
    additionalClass[initOptions.constants.MESSAGE_ERROR] = 'error';
    additionalClass[initOptions.constants.MESSAGE_NEUTRAL] = 'neutral';

    if (additionalClass[messageOptions.state]) {
      $hintContainer.addClass(additionalClass[messageOptions.state]);
    }
  };

  $.shopgate.systemMessage.showPopup = function (messageOptions, initOptions) {
    initOptions = initOptions || {};

    var defaults = {
      title: '',
      message: '',
      useNativePopup: initOptions.useNativePopup,
      successTimeout: initOptions.successTimeout
    };

    messageOptions = messageOptions || {};
    messageOptions = $.extend({}, defaults, messageOptions);

    // if the message options state is error then add the title "error" to the notification/modal
    messageOptions.title = (initOptions.constants && messageOptions.state == initOptions.constants.MESSAGE_ERROR && messageOptions.title == '') ? $.i18n._('modal_alert_title_error') : messageOptions.title;

    var disappearTimeout = (initOptions.constants && messageOptions.state == initOptions.constants.MESSAGE_ERROR) ? 0 : messageOptions.successTimeout;

    var params = {
      src: 'sgapi:generic_notifications', // TODO: change for webapp
      presentationType: "centeredFade",
      speedFactor: 0.9,
      timeout: disappearTimeout,
      offsets: { top: 0, bottom: 0 },
      executeOnClick: false,
      notificationParams: {
        genericNotification: {
          title: messageOptions.title,
          message: messageOptions.message,
          primaryButton: $.i18n._('modal_alert_button_ok'),
          primaryButtonAction: null,
          secondaryButton: false,
          secondaryButtonAction: null,
          closeButtonOutsideNotification: false,
          customCssClass: null
        }
      }
    };

    // TODO call showPopup from genericNotification -> make it real generic
    // NOTIFICATION POPUP

    if (messageOptions.useNativePopup && typeof pageInformation != 'undefined' && pageInformation.visible) {
      // to make the generic notification function work i used $('body').
      $('body').genericNotification(params);
    } else if (messageOptions.useNativePopup && typeof pageInformation != 'undefined' && !pageInformation.visible) {
      // don't add another popup with the same message to the commands if the view is not visible
      if ($.shopgate.systemMessage.previousMessage == messageOptions.message) {
        return;
      }

      $.shopgate.systemMessage.previousMessage = messageOptions.message;

      $(document).on('sgViewAppear', function () {
        // in the mean time the previous message could have been reset
        if ($.shopgate.systemMessage.previousMessage) {
          $('body').genericNotification(params);
          // reset the previous message so that the next notification can be shown
          $.shopgate.systemMessage.previousMessage = '';
        }

      });
    } else {
      // to make the generic notification function work i used $('body').
      $('body').genericNotification(params);
    }
  };

  /**
   * Plugin that shows a message as a modal or "native" popup (in apps).
   * @param notificationOptions
   * notificationOptions.src: The source view which should be used for the native popup in apps
   * notificationOptions.presentationType: Animation type of the native popup; see specification "presentNotification"
   * notificationOptions.speedFactor: Animation speed of the native popup; see specification "presentNotification"
   * notificationOptions.timeout (ms): Timeout for the duration of the popup to be shown (native and modal)
   * notificationOptions.notificationParams: content of the popup (attributes: title, message, primaryButton, primaryButtonAction, secondaryButton, secondaryButtonAction, offset)
   * notificationOptions.executeOnClick: whether or not display the popup on clicking the element or show it instantly,
   * notificationOptions.useNativePopup: uses the value $.shopgate.systemMessage.options.useNativePopup which is set on initialisation of the system messaging as default (LazyDataManager1Component->getSupportNativePopup)
   * @returns {*|DomTextMatcher|tinymce.dom.DomQuery|tinymce.ui.Collection}
   */
  $.fn.genericNotification = function (notificationOptions) {
    var notificationDefaults = {
      src: 'sgapi:generic_notifications',
      presentationType: "centeredFade",
      speedFactor: 0.9,
      timeout: null, // time in ms
      notificationParams: {},
      executeOnClick: true,
      useNativePopup: $.shopgate.systemMessage.options.useNativePopup
    };

    notificationOptions = notificationOptions || {};

    // if there is no subobject "genericNotification" in the notificationParams already, we create it for further processing
    if (notificationOptions.notificationParams) {
      var genericParams = notificationOptions.notificationParams;

      if (!genericParams.genericNotification) {
        notificationOptions.notificationParams = { genericNotification: genericParams };
      }
    }

    notificationOptions = $.extend({}, notificationDefaults, notificationOptions);

    return this.each(function () {
      var notificationTrigger = $(this);

      if (notificationOptions.executeOnClick) {
        notificationTrigger.bind('click', function (e) {
          e.preventDefault();
          _showPopup(notificationOptions);
        });
      } else {
        _showPopup(notificationOptions);
      }

      function _showPopup(options) {
        if (!options.useNativePopup) {
          // TODO find a way to also present the notification as modal -> exact same appearance as updateTemplateContent
          var params = options.notificationParams.genericNotification;
          $.shopgate.modal({
            title: params.title,
            closeButtonOutsideModal: params.closeButtonOutsideNotification,
            body: params.message,
            closeExistingModals: true,
            closeOnBackdropTap: false,
            timer: options.timeout,
            offsets: options.offsets,
            buttons: {
              primaryButton: params.primaryButton,
              primaryButtonAction: params.primaryButtonAction,
              secondaryButton: params.secondaryButton,
              secondaryButtonAction: params.secondaryButtonAction,
              tertiaryButton: params.tertiaryButton,
              tertiaryButtonAction: params.tertiaryButtonAction,
            }
          });
        } else {
          options.notificationParams.genericNotification.ownerPageId = pageInformation.pageId;
          options.notificationParams.genericNotification.ownerTab = pageInformation.tab;
          // as we set the timeout in ms and the generic notification system uses s we have to adjust the timeout
          options.timeout = options.timeout / 1000;
          SGAction.presentNotification(options);
        }
      }
    });
  };

})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-system-message.js